import { render } from "./_unauthorized.vue?vue&type=template&id=80ba2056"
import script from "./_unauthorized.vue?vue&type=script&lang=js"
export * from "./_unauthorized.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./_unauthorized.vue?vue&type=style&index=0&id=80ba2056&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/root/dirif/prod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__